const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAws(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_aws") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30,19.152v1.273c0,2.307-2.545,4.693-5.648,4.693H7.648C4.506,25.118,2,22.771,2,20.424V19.152Z",
    style: {
      fill: "#9d5125"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.778,6.782A7.112,7.112,0,0,1,19.3,11a3.638,3.638,0,0,1,2.068-.636,3.583,3.583,0,0,1,3.619,3.5A5.69,5.69,0,0,1,30,18.993v.477c0,2.347-2.545,4.693-5.688,4.693H7.648C4.506,24.163,2,21.816,2,19.47v-.477A5.527,5.527,0,0,1,5.619,14.14v-.2A7.129,7.129,0,0,1,12.778,6.782Z",
    style: {
      fill: "#f58535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,15.095,7.131,21.618H8.244l.438-1.591h1.909l.4,1.591H12.1l-1.75-6.523Zm-.159,4.1.8-3.222h0l.756,3.222Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.795 20.226 16.756 20.226 15.881 15.095 14.767 15.095 13.932 20.186 13.892 20.186 13.017 15.095 11.983 15.095 13.256 21.657 14.449 21.657 15.284 16.726 15.324 16.726 16.159 21.657 17.392 21.657 18.705 15.095 17.631 15.095 16.795 20.226",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.085,18.078l-.716-.239c-.716-.278-.994-.6-.994-1.153a.9.9,0,1,1,1.79,0v.119H23.2v-.159c0-.676-.159-1.71-1.869-1.71A1.8,1.8,0,0,0,19.3,16.805a1.729,1.729,0,0,0,1.392,1.79l.716.239a1.1,1.1,0,0,1,.955,1.153.928.928,0,0,1-.994.955q-1.074,0-1.074-1.193v-.159H19.261v.159a1.786,1.786,0,0,0,1.989,1.989c1.312,0,2.187-.557,2.187-1.949A1.728,1.728,0,0,0,22.085,18.078Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/aws.f5f128f08a260a6a712dd9faf83db05a.svg";
export { ForwardRef as ReactComponent };